<template>
    <div class="wrap">
        <listHeader
            :title="postData.csid > 0 ? '编辑学员' : '新增学员'"
            :back="true"></listHeader>

        <div class="wrap-list-content">

            <hro-tab
                scenario="cstudent"
                active="info"
                :cbid="postData.cbid"
                :csid="postData.csid"
            ></hro-tab>

            <div class="wrap-form-info">
                <a-row>
                    <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                        <a-form :form="form">

                            <a-form-item
                                label="学员"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请输入学员姓名" v-decorator="['csname', {rules: [{ required: true, max: 64, message: '请输入学员姓名' }], initialValue: ''}]"/>
                            </a-form-item>

                            <a-form-item
                                label="手机号"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请填写手机号"
                                         v-decorator="['mobile', {rules: [{ required: true, validator: requiredMobile,  message: '请填写正确的手机号' }]} ]"/>
                            </a-form-item>

                            <a-form-item
                                label="身份证"
                                v-bind="formItemLayout"
                            >
                                <a-input placeholder="请填写身份证"
                                         v-decorator="['idcard', {rules: [{ required: false, validator: checkIdcard,  message: '请填写正确的身份证号码' }]} ]"/>
                            </a-form-item>

                            <a-form-item
                                label="结业日期"
                                v-bind="formItemLayout"
                            >
                                <a-date-picker
                                    style="width: 100%"
                                    placeholder="请选择学员结业日期"
                                    v-decorator="['finishtime',{rules: [{ required: false, message: '请选择学员结业日期' }]} ]"
                                />
                            </a-form-item>

                            <a-form-item
                                v-bind="formBtnLayout"
                            >
                                <a-button type="primary" @click="create">确定</a-button>
                            </a-form-item>
                        </a-form>
                    </a-col>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
import listHeader from '@/components/list/listHeader';
import moment from "moment";
import hroTab from '@/components/list/tab';

export default {
    components: {
        listHeader,
        hroTab,
    },
    data() {
        return {
            scenario: 'cstudentCreate',
            visible: false, // 是否显示图片src
            formItemLayout: {
                labelCol: {
                    span: 5
                },
                wrapperCol: {
                    span: 19
                },
            },
            formBtnLayout: {
                wrapperCol: {
                    span: 19,
                    offset: 5,
                },
            },
            form: this.$form.createForm(this),
            postData: {
                'cbid': '',
                'csid': '',
            },
            data: {},
            config: {},
            dateFormat: 'YYYY-MM-DD',
        }
    },
    Watch: {
    },
    created() {
        this.setData();
        this.getData();
    },
    methods: {
        setData() {
            for (let i in this.postData) {
                if (this.$route.query[i] === undefined) continue;
                this.postData[i] = this.$route.query[i];
            }
        },
        getData() {
            // 查询数据
            this.http('/manage/cstudent/info', this.postData, (res) => {
                this.data = res.data;
                this.config = res.config;

                if (res.data.csid) {
                    this.$nextTick(() => {
                        this.form.setFieldsValue({
                            csname: res.data.csname,
                            mobile: res.data.mobile,
                            idcard: res.data.idcard,
                            finishtime: res.data.finishtime != '0' ? moment(res.data.finishtime_str, this.dateFormat) : null,
                        });
                    });
                }

            }, null, 2);
        },
        create() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {
                        let url = '';
                        if(this.postData.csid > 0) {
                            url = '/manage/cstudent/edit';
                            values.csid = this.postData.csid;
                        } else {
                            url = '/manage/cstudent/save';
                            values.cbid = this.postData.cbid;
                        }

                        values.finishtime = values.finishtime ? values.finishtime.format(this.dateFormat) : '';

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'}, (res) => {
                                if (this.postData.csid == '') {
                                    this.$router.go(-1);
                                } else {
                                    this.getData();
                                }
                            });
                        }, null, 1);
                    }
                }
            );
        },
    },
}
</script>

<style lang="less" src="../../assets/css/add/add.less"></style>
